/**
 * 文章相关
 */

import axios from '../utils/http';

// 文章详情
const getArticleView = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'get',
        url: '/v1/article/getArticleView'
    })
}

// 相关阅读
const getRelatedReading = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'get',
        url: '/v1/article/getRelatedReading'
    })
}

// 文章评论列表
const getCommentList = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'get',
        url: '/v1/comments/getCommentList'
    })
}
// 发表评论
const addComments = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'post',
        url: '/v1/comments/add',
        header: {
            userid: params.userid
        }
    })
}

// 获取分类树
const getCategoryTree = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'get',
        url: '/category/getCategoryTree'
    })
}


// 文章列表通用接口+分类+城市
const getArticleList = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'get',
        url: '/v1/article/getArticleList'
    })
}

// 获取海拔
const getTopAds = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'post',
        url: '/v1/ad/getTopAds'
    })
}



const article = {
    getArticleView,
    getRelatedReading,
    getCommentList,
    addComments,
    getCategoryTree,
    getArticleList,
    getTopAds
}
 
export default article